interface TokenPayload {
  "https://www.johnlewis.com/auth/customerId": string;
  "https://www.johnlewis.com/auth/email": string;
  "https://www.johnlewis.com/auth/login-type": string;
  "https://www.johnlewis.com/auth/identities": string[];
  iss: string;
  sub: string;
  aud: string[];
  iat: number;
  exp: number;
  azp: string;
  scope: string;
}

export async function getAuthUserData() {
  const accessToken = await getAccessToken();

  if (!accessToken) {
    return null;
  }

  try {
    const parsedTokenData = JSON.parse(
      // @ts-ignore
      atob(accessToken.split(".")[1]),
    ) as TokenPayload;

    return {
      customerId: parsedTokenData["https://www.johnlewis.com/auth/customerId"],
      email: parsedTokenData["https://www.johnlewis.com/auth/email"],
    };
  } catch {
    return null;
  }
}

let retryCount = 0;

async function getAccessToken(): Promise<string | null | undefined> {
  const auth0 = window.__auth0__ || window.auth0;

  if (auth0) return await auth0.getTokenIfAuthenticated();

  if (retryCount < 5) {
    await delay(200);
    retryCount += 1;
    return await getAccessToken();
  }

  return;
}

function delay(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
